import React, { useState, useEffect } from "react";
import axios from "axios";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import Container from "react-bootstrap/Container";
import Modal from "react-modal";
import SmallPoslednjiPozdrav from "./SmallPoslednjiPozdrav";
import MediumPPozdrav from "./MediumPPozdrav";
import PoslednjiPozdrav from "./PoslednjiPozdrav";
import Umrlica from "./Umrlica";
import SmallUmrlica from "./SmallUmrlica";
import BigUmrlica from "./BigUmrlica";
import QuarterUmrlica from "./QuarterUmrlica";
import Reklama from "./Reklama";
import SmallReklama from "./SmallReklama";
import MediumReklama from "./MediumReklama";
import DatePicker from "react-date-picker";
import "react-date-picker/dist/DatePicker.css";
import "react-calendar/dist/Calendar.css";
import { useHistory } from "react-router-dom";
Modal.setAppElement("#root");

const limit = 10;

function Umrlice({
  posts,
  cities,
  count,
  setCount,
  setDateCreated,
  dateCreated,
  offset,
  setOffset,
  selectedCity,
  setSelectedCity,
  isLoggedIn,
}) {
  const [selectedPost, setSelectedPost] = useState(null);
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [modalType, setModalType] = useState("");
  const [modalSize, setModalSize] = useState(0);
  const [modalState, setModalState] = useState(false);
  const [relatedPosts, setRelatedPosts] = useState([]);
  let userRole = localStorage.getItem("userRole");

  /*  useEffect(() => {
    const postId = localStorage.getItem("postId");
  }, [selectedPost]); */
  useEffect(() => {
    console.log(selectedPost);
    if (selectedPost && modalIsOpen) {
      fetchRelatedPosts(selectedPost.id);
    }
  }, [selectedPost, modalIsOpen]);

  const fetchRelatedPosts = async (postId) => {
    try {
      const response = await axios.get(
        `https://radojicictijanaa.pythonanywhere.com/api/posts/?parent=${postId}`
      );

      setRelatedPosts(response.data);
    } catch (error) {
      console.log("Error fetching posts:", error);
    }
  };

  const stateSetter = () => {
    if (modalState === false) {
      setModalState(true);
    } else {
      setModalState(false);
    }
  };

  const history = useHistory();
  const closeModal = () => {
    setModalType("");
    setModalSize(0);
    setModalIsOpen(false);
    stateSetter();
    history.goBack();
  };
  /* const handleNumberClick = (pageNumber) => {
    const newOffset = (pageNumber - 1) * limit;
    setOffset(newOffset);
  };*/
  const openModal = (post, type, size) => {
    setSelectedPost(post);
    setModalType(type);
    setModalSize(size);
    setModalIsOpen(true);
    setModalState(true);
    window.scrollTo({
      top: 0,
    });
    fetchRelatedPosts(post.id);
    localStorage.setItem("postId", post.id);
    window.history.pushState(null, "", `/posts/${post.id}`);
  };
  window.onpopstate = () => {
    if (modalIsOpen === true) {
      setModalIsOpen(false);
    }
  };
  const goToFormaZaPopunjavanje = (selectedPost) => {
    if (!isLoggedIn) {
      window.location.href = "/login";
    } else if (selectedPost) {
      localStorage.setItem("postId", selectedPost.id);
      window.location.href = "/redirect-form";
    }
  };
  const totalPages = Math.ceil(count / limit);

  const handlePreviousPage = () => {
    setOffset(offset - limit);
  };

  const handleUpdateButton = (id) => {
    window.location.href = `/posts/update/${id}`;
  };

  const LARGE = 3;
  const MEDIUM = 2;
  const SMALL = 1;
  const TINY = 4;
  const WHOLE = "WHOLE";
  const ROW = "ROW";
  const COLUMN = "COLUMN";
  const TINY_COLUMN = "TINY_COLUMN";

  function getPostOrder(POSTS) {
    let order = [];
    for (let i = 0; i < POSTS.length; i++) {
      order[i] = { post: null, type: WHOLE, size: LARGE };
    }

    POSTS.forEach((post) => {
      for (let i = 0; i < order.length; i++) {
        const slot = order[i];

        if (post.size === LARGE) {
          if (slot.type === WHOLE && slot.post === null) {
            order[i] = { post: post, type: WHOLE, size: LARGE };
            break;
          }
        } else if (post.size === MEDIUM) {
          if (slot.type === WHOLE && slot.post === null) {
            order[i] = {
              left: { post: post, type: WHOLE, size: MEDIUM },
              right: null,
              type: ROW,
            };
            break;
          } else if (slot.type === ROW) {
            if (slot.left === null) {
              order[i].left = { post: post, type: WHOLE, size: MEDIUM };
              break;
            }
            if (slot.right === null) {
              order[i].right = { post: post, type: WHOLE, size: MEDIUM };
              break;
            }
          }
        } else if (post.size === SMALL) {
          if (slot.type === WHOLE && slot.post === null) {
            order[i] = {
              left: {
                top: { post: post, type: WHOLE, size: SMALL },
                bottom: null,
                type: COLUMN,
              },
              right: null,
              type: ROW,
            };
            break;
          } else if (slot.type === ROW) {
            if (slot.left === null) {
              order[i].left = {
                top: { post: post, type: WHOLE, size: SMALL },
                bottom: null,
                type: COLUMN,
              };
              break;
            } else if (slot.left.type === COLUMN) {
              if (slot.left.top === null) {
                order[i].left.top = { post: post, type: WHOLE, size: SMALL };
                break;
              } else if (slot.left.bottom === null) {
                order[i].left.bottom = { post: post, type: WHOLE, size: SMALL };
                break;
              }
            }

            if (slot.right === null) {
              order[i].right = {
                top: { post: post, type: WHOLE, size: SMALL },
                bottom: null,
                type: COLUMN,
              };
              break;
            } else if (slot.right.type === COLUMN) {
              if (slot.right.top === null) {
                order[i].right.top = { post: post, type: WHOLE, size: SMALL };
                break;
              } else if (slot.right.bottom === null) {
                order[i].right.bottom = {
                  post: post,
                  type: WHOLE,
                  size: SMALL,
                };
                break;
              }
            }
          }
        } else if (post.size === TINY) {
          if (slot.type === WHOLE && slot.post === null) {
            order[i] = {
              left: {
                top: {
                  top: { post: post, type: WHOLE, size: TINY },
                  bottom: null,
                  type: TINY_COLUMN,
                },
                bottom: null,
                type: COLUMN,
              },
              right: null,
              type: ROW,
            };
            break;
          } else if (slot.type === ROW) {
            if (slot.left === null) {
              order[i].left = {
                top: {
                  top: { post: post, type: WHOLE, size: TINY },
                  bottom: null,
                  type: TINY_COLUMN,
                },
                bottom: null,
                type: COLUMN,
              };
              break;
            } else if (slot.left.type === COLUMN) {
              if (slot.left.top === null) {
                order[i].left.top = {
                  top: { post: post, type: WHOLE, size: TINY },
                  bottom: null,
                  type: TINY_COLUMN,
                };
                break;
              } else if (slot.left.top.type === TINY_COLUMN) {
                if (slot.left.top.top === null) {
                  order[i].left.top.top = {
                    post: post,
                    type: WHOLE,
                    size: TINY,
                  };
                  break;
                } else if (slot.left.top.bottom === null) {
                  order[i].left.top.bottom = {
                    post: post,
                    type: WHOLE,
                    size: TINY,
                  };
                  break;
                }
              }

              if (slot.left.bottom === null) {
                order[i].left.bottom = {
                  top: { post: post, type: WHOLE, size: TINY },
                  bottom: null,
                  type: TINY_COLUMN,
                };
                break;
              } else if (slot.left.bottom.type === TINY_COLUMN) {
                if (slot.left.bottom.top === null) {
                  order[i].left.bottom.top = {
                    post: post,
                    type: WHOLE,
                    size: TINY,
                  };
                  break;
                } else if (slot.left.bottom.bottom === null) {
                  order[i].left.bottom.bottom = {
                    post: post,
                    type: WHOLE,
                    size: TINY,
                  };
                  break;
                }
              }
            }

            if (slot.right === null) {
              order[i].right = {
                top: {
                  top: { post: post, type: WHOLE, size: TINY },
                  bottom: null,
                  type: TINY_COLUMN,
                },
                bottom: null,
                type: COLUMN,
              };
              break;
            } else if (slot.right.type === COLUMN) {
              if (slot.right.top === null) {
                order[i].right.top = {
                  top: { post: post, type: WHOLE, size: TINY },
                  bottom: null,
                  type: TINY_COLUMN,
                };
                break;
              } else if (slot.right.top.type === TINY_COLUMN) {
                if (slot.right.top.top === null) {
                  order[i].right.top.top = {
                    post: post,
                    type: WHOLE,
                    size: TINY,
                  };
                  break;
                } else if (slot.right.top.bottom === null) {
                  order[i].right.top.bottom = {
                    post: post,
                    type: WHOLE,
                    size: TINY,
                  };
                  break;
                }
              }

              if (slot.right.bottom === null) {
                order[i].right.bottom = {
                  top: { post: post, type: WHOLE, size: TINY },
                  bottom: null,
                  type: TINY_COLUMN,
                };
                break;
              } else if (slot.right.bottom.type === TINY_COLUMN) {
                if (slot.right.bottom.top === null) {
                  order[i].right.bottom.top = {
                    post: post,
                    type: WHOLE,
                    size: TINY,
                  };
                  break;
                } else if (slot.right.bottom.bottom === null) {
                  order[i].right.bottom.bottom = {
                    post: post,
                    type: WHOLE,
                    size: TINY,
                  };
                  break;
                }
              }
            }
          }
        }
      }
    });

    order.forEach((block, i) => {
      if (block.type === ROW) {
        if (block.left.type === COLUMN) {
          if (block.left.bottom && block.left.bottom.type === TINY_COLUMN) {
            const adRight = block.right === null;
            const adLeftBottomBottom = block.left.bottom.bottom === null;
            if (adRight && adLeftBottomBottom) {
              order[i].right = {
                type: COLUMN,
                top: {
                  type: TINY_COLUMN,
                  top: block.left.bottom.top,
                  bottom: null,
                },
                bottom: "hidden",
              };
              order[i].left.bottom.bottom = "hidden";
              order[i].left.bottom.top = "hidden";
            }
          } else if (block.left.top && block.left.top.type === TINY_COLUMN) {
            const adRight = block.right === null;
            const adLeftBottom = block.left.bottom === null;
            const adLeftTopBottom = block.left.top.bottom === null;
            if (adRight && adLeftBottom && adLeftTopBottom) {
              order[i].left.bottom = "hidden";
              order[i].left.top.bottom = "hidden";
              order[i].right = {
                type: COLUMN,
                top: {
                  type: TINY_COLUMN,
                  top: null,
                  bottom: "hidden",
                },
                bottom: "hidden",
              };
            }
          } else {
            const adRight = block.right === null;
            const adLeftBottom = block.left.bottom === null;
            if (adRight && adLeftBottom) {
              order[i].left.bottom = "hidden";
              order[i].right = {
                type: COLUMN,
                top: null,
                bottom: "hidden",
              };
            }
          }
        }
      }
    });
    return order;
  }

  function renderPostRow(post, index) {
    return (
      <div className="row" key={index}>
        <div className="col-lg-6 col-sm-12 col-md-12">
          {renderPost(post.left, MEDIUM, index)}
        </div>
        <div className="col-lg-6 col-sm-12 col-md-12">
          {renderPost(post.right, MEDIUM, index)}
        </div>
      </div>
    );
  }

  function renderPostColumn(post, index) {
    return (
      <div className="col" key={index}>
        <div className="row-6">{renderPost(post.top, SMALL, index)}</div>
        <div className="row-6">{renderPost(post.bottom, SMALL, index)}</div>
      </div>
    );
  }

  function renderPostTinyColumn(post, index) {
    return (
      <div className="col" key={index}>
        <div className="row-6">{renderPost(post.top, TINY, index)}</div>
        <div className="row-6">{renderPost(post.bottom, TINY, index)}</div>
      </div>
    );
  }

  function renderPostWhole(post, index) {
    if (post.post === null) {
      return;
    }

    if (post.size === LARGE) {
      return (
        <div
          style={{ paddingTop: "20px" }}
          key={index}
          onClick={() => openModal(post.post, "umrlica", 3)}
        >
          <BigUmrlica
            userRole={userRole}
            modalIsOpen={modalIsOpen}
            post={post.post}
          />
        </div>
      );
    } else if (post.size === MEDIUM) {
      return (
        <div
          key={index}
          style={{ paddingTop: "20px" }}
          onClick={() => openModal(post.post, "umrlica", 2)}
        >
          <Umrlica
            userRole={userRole}
            modalIsOpen={modalIsOpen}
            post={post.post}
          />
        </div>
      );
    } else if (post.size === SMALL) {
      return (
        <div
          style={{ paddingTop: "20px" }}
          key={index}
          onClick={() => openModal(post.post, "umrlica", 1)}
        >
          <SmallUmrlica
            userRole={userRole}
            modalIsOpen={modalIsOpen}
            post={post.post}
          />
        </div>
      );
    } else if (post.size === TINY) {
      return (
        <div
          style={{ paddingTop: "20px" }}
          key={index}
          onClick={() => openModal(post.post, "umrlica", 1)}
        >
          <QuarterUmrlica
            userRole={userRole}
            modalIsOpen={modalIsOpen}
            post={post.post}
          />
        </div>
      );
    } else {
      return <p>invalid post size</p>;
    }
  }

  function renderPost(post, size, index) {
    if (post === null || post === "hidden") {
      const displayStyle = {
        display: post === "hidden" ? "none" : "block",
      };
      if (size === MEDIUM) {
        return (
          <div key={index} style={displayStyle}>
            <MediumReklama />
          </div>
        );
      } else if (size === SMALL) {
        return (
          <div key={index} style={displayStyle}>
            <Reklama />
          </div>
        );
      } else if (size === TINY) {
        return (
          <div key={index} style={displayStyle}>
            <SmallReklama />
          </div>
        );
      }
    } else if (post.type === WHOLE) {
      return renderPostWhole(post, index);
    } else if (post.type === ROW) {
      return renderPostRow(post, index);
    } else if (post.type === COLUMN) {
      return renderPostColumn(post, index);
    } else if (post.type === TINY_COLUMN) {
      return renderPostTinyColumn(post, index);
    }
  }

  const exportPostAsImage = () => {
    window.open(`/posts/${selectedPost.id}?print=true`);
  };
  return (
    <Container style={{ paddingRight: "8%", paddingLeft: "8%" }}>
      <div className="filters">
        <div className="filter-group">
          <label htmlFor="cityFilter">Filtriraj po gradu</label>
          <select
            id="cityFilter"
            className="filter-select"
            value={selectedCity}
            onChange={(e) => setSelectedCity(e.target.value)}
          >
            <option value={""}>Odaberi grad</option>
            {cities.map((city) => (
              <option key={city.id} value={city.id}>
                {city.name}
              </option>
            ))}
          </select>
        </div>
        <div className="filter-group">
          <label htmlFor="dateFilter">Filtriraj po datumu</label>
          <DatePicker
            name="death_date"
            onChange={setDateCreated}
            value={dateCreated}
            className="FormaZaPopunjavanje-input"
            style={{ marginTop: "8px" }}
            format="dd/MM/y"
          />
        </div>
      </div>
      {getPostOrder(posts).map((row, rowIndex) => {
        return renderPost(row, row.size, rowIndex);
      })}

      <div className="pagination">
        {offset !== 0 && (
          <button
            onClick={handlePreviousPage}
            disabled={offset === 0} // Disable on first page
          >
            Prethodna
          </button>
        )}
        {/* Render clickable numbers for pages */}
        {totalPages > 1 && (
          <div>
            {Array.from({ length: totalPages }).map((_, index) => {
              if (
                index === 0 ||
                index === totalPages - 1 ||
                (index >= offset / limit - 1 && index <= offset / limit + 1)
              ) {
                return (
                  <button
                    key={index}
                    onClick={() => setOffset(index * limit)}
                    disabled={index * limit === offset}
                  >
                    {index + 1}
                  </button>
                );
              } else if (
                index === offset / limit + 2 ||
                index === offset / limit - 2
              ) {
                return <span key={index}>...</span>;
              }
              return null;
            })}

            {offset + limit < count && (
              <button key={count} onClick={() => setOffset(offset + limit)}>
                Sledeća
              </button>
            )}
          </div>
        )}
      </div>
      <Modal
        isOpen={modalIsOpen}
        onRequestClose={closeModal}
        contentlabel="Post Modal"
        size="lg"
        style={{ padding: "0px" }}
      >
        <Container style={{ paddingLeft: "8%", paddingRight: "8%" }}>
          <Row>
            {selectedPost && modalType === "umrlica" && modalSize === 1 && (
              <SmallUmrlica
                userRole={userRole}
                modalIsOpen={modalIsOpen}
                post={selectedPost}
              />
            )}
            {selectedPost && modalType === "umrlica" && modalSize === 2 && (
              <Umrlica
                userRole={userRole}
                modalIsOpen={modalIsOpen}
                post={selectedPost}
              />
            )}

            {selectedPost && modalType === "umrlica" && modalSize === 3 && (
              <BigUmrlica
                userRole={userRole}
                modalIsOpen={modalIsOpen}
                post={selectedPost}
              />
            )}
          </Row>

          <button
            style={{
              float: "right",
              borderRadius: "0px",
              marginTop: "2%",
              padding: "5px",
              backgroundColor: "gray",
              color: "white",
              border: "none",
            }}
            onClick={closeModal}
          >
            Zatvori
          </button>
          <div>
            {(userRole === "superadmin" || userRole === "admin") && (
              <button
                style={{
                  marginTop: "2%",
                  padding: "5px",
                  backgroundColor: "#c9b904",

                  color: "white",
                  border: "none",
                  borderRadius: "0px",
                }}
                onClick={() => handleUpdateButton(selectedPost.id)}
              >
                Uredi objavu
              </button>
            )}
            <button
              style={{
                marginTop: "2%",
                padding: "5px",
                backgroundColor: "green",
                color: "white",
                borderRadius: "0px",
                marginLeft: "1%",
                border: "none",
              }}
              onClick={() => exportPostAsImage(`post-${selectedPost.id}`)}
            >
              Štampaj
            </button>
            {selectedPost && modalType === "umrlica" && (
              <button
                className="modal-btn-predaj-pp"
                onClick={() => goToFormaZaPopunjavanje(selectedPost)}
              >
                Predaj poslednji pozdrav
              </button>
            )}
          </div>

          {/* {uniquePoslednjiPozdravPostsSmall
            .filter((post) => post.name === selectedPost.name)
            .map((post) => (
              <div>
                <hr></hr>
                <SmallPoslednjiPozdrav post={post} key={post.id} />
              </div>
            ))} */}
          {selectedPost && (
            <Row>
              <h3 style={{ textAlign: "center", paddingTop: "30px" }}>
                Poslednji pozdravi
              </h3>
              {relatedPosts
                .filter((relatedPost) => relatedPost.parent === selectedPost.id)
                .map((relatedPost) => {
                  if (
                    relatedPost.type === "poslednji_pozdrav" &&
                    relatedPost.size === 1
                  ) {
                    return (
                      <Col
                        style={{ paddingTop: "20px" }}
                        sm={12}
                        md={12}
                        lg={6}
                        key={relatedPost.id}
                      >
                        <SmallPoslednjiPozdrav post={relatedPost} />
                      </Col>
                    );
                  } else if (
                    relatedPost.type === "poslednji_pozdrav" &&
                    relatedPost.size === 2
                  ) {
                    return (
                      <Col
                        style={{ paddingTop: "20px" }}
                        sm={12}
                        md={12}
                        lg={6}
                        key={relatedPost.id}
                      >
                        <MediumPPozdrav post={relatedPost} />
                      </Col>
                    );
                  } else if (
                    relatedPost.type === "poslednji_pozdrav" &&
                    relatedPost.size === 3
                  ) {
                    return (
                      <Col
                        style={{ paddingTop: "20px" }}
                        sm={12}
                        md={12}
                        lg={12}
                        key={relatedPost.id}
                      >
                        <PoslednjiPozdrav post={relatedPost} />
                      </Col>
                    );
                  }
                  return null; // Add this line to handle cases where the post type or size doesn't match
                })}
            </Row>
          )}
        </Container>
      </Modal>
    </Container>
  );
}

export default Umrlice;
